import { render, staticRenderFns } from "./NewsFilter.vue?vue&type=template&id=5d2ec5d6&"
import script from "./NewsFilter.vue?vue&type=script&lang=js&"
export * from "./NewsFilter.vue?vue&type=script&lang=js&"
import style0 from "./NewsFilter.vue?vue&type=style&index=0&id=5d2ec5d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports